<template>
  <v-container>
    <v-col class="mt-4 pt-0">
      <div class="mt-2">
        <p>Select areas to avoid during voyage</p>
      </div>
      <v-card :flat="true" class="overflow-y-auto" max-height="300px">
        <v-checkbox
          v-for="area in allAreas"
          :key="area.id"
          :label="area.name"
          :value="area"
          class="ma-0 pa-0"
          :ripple="false"
          dense
          v-model="selectedNoGoAreasModel"
        ></v-checkbox>
      </v-card>
    </v-col>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "NoGoAreasSettings",
  data() {
    return {};
  },
  computed: {
    ...mapState("weatherRouting/customAreasModule", ["allAreas"]),
    ...mapState("weatherRouting/formModule", ["selectedNoGoAreas"]),
    selectedNoGoAreasModel: {
      get() {
        return this.selectedNoGoAreas;
      },
      set(value) {
        this.$store.commit(
          "weatherRouting/formModule/SET_SELECTED_NO_GO_AREAS",
          value,
          { root: true }
        );
      },
    },
  },
  methods: {},
};
</script>